export function createAdminBC(c_name, c_id, a_name,a_id, co_name, co_id, ch_name, ch_id, l_name, l_id) {
    const bc = []
    if (c_id > 0)
      bc.push ({ text: c_name, href: '/areas/' + c_id })//#
    if (a_id > 0)
      bc.push ({ text: a_name, href: '/courses/' + a_id })//#
    if (co_id > 0)
      bc.push ({ text: co_name, href: '/course_admin_content/' + co_id })//#
    if (ch_id > 0)
      bc.push ({ text: ch_name, href: '/course_admin_content/' + co_id })//#
    if (l_id > 0)
      bc.push ({ text: l_name, href: '/lesson_admin_content/' + l_id })//#
    return bc
}